import getLocationRouterSelect from 'modules/router/selectors/get-location'

export const getLocationState = (state) => {
  const location = getLocationRouterSelect(state)
  const locationState = location.state

  return {
    location,
    locationState,
    replacingWorkoutExerciseId: locationState?.replacingWorkoutExerciseId,
    isReplacing: !!locationState?.replacingWorkoutExerciseId,
    isVideoUrl: location?.pathname?.endsWith?.('-video'),
    shouldShowContent: !location?.pathname?.endsWith?.('-video')
  }
}
